<template>
  <PainelLayout>
    <div class="row align-items-center">
      <div class="col-6">
        <h1>Resumo</h1>
      </div>
      <div class="col-6 text-end">
        <RentalSearch />
      </div>
    </div>
    <hr/>

    <ResumeFilters
      :filters="filters"
      :status-options="availableStatuses"
    />

    <div v-if="!rentals_loading">
      <div v-if="filteredList.length != 0" class="row">
        <RentalCard v-for="loc in filteredList" :key="loc.id"
          :status="loc.status"
          :rental-id="'code'"
          :client-name="loc.client.name"
          :value="loc.final_amount"
          :show-value="isOpeto ? false : true"
          :start-date="loc.dateStart"
          :end-date="loc.date_end"
          :location="loc.city"
          :delivery-type="loc.withdrawal ? 'pickup' : 'delivery'"
          :next-action-date="nextActionDate(loc)"
          :to="`/rental/details?id=${loc.id}`"
        />
      </div>
      <div v-else class="text-center text-muted p-4">
        Nenhuma locação encontrada.
      </div>
      <div style="height: 15px;"></div>
    </div>
    <div v-else class="d-flex justify-content-center p-3 mb-4">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div style="height: 10px;"></div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { usePermissions } from '@/composables/usePermissions.js';
import { onMounted, ref } from 'vue';
import { rental } from '@/models/rental';
import statusFormat from '@/services/statusFormat';
import dateFormat from '@/services/dateFormat';
import RentalCard from '@/components/RentalCard.vue';
import ResumeFilters from '@/components/ResumeFilters.vue';
import RentalSearch from '@/components/RentalSearch.vue';
import { useRentalFilters } from '@/composables/useRentalFilters';

export default {
  name: "ResumeView",
  components: { PainelLayout, RentalCard, ResumeFilters, RentalSearch },
  setup(props) {
    const { isAdmin, hasLevel, can, userLevel, isOpeto } = usePermissions();
    const painelmodel = rental();
    var rentals_loading = ref(true);
    var rentals = ref([]);

    const { filters, filteredList, availableStatuses, resetFilters, nextActionDate } = useRentalFilters(rentals);

    async function getResume() {
      rentals_loading.value = true;
      rentals.value = await painelmodel.getResume();
      rentals_loading.value = false;
    }

    onMounted(() => {
      getResume();
    })

    return {
      isAdmin, hasLevel, can, statusFormat, dateFormat,
      userLevel, rentals_loading,
      getResume, rentals,
      filters, filteredList, availableStatuses, resetFilters, nextActionDate
    };
  }
}
</script>